import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import ConsentCheckboxField from "./ConsentCheckboxField";

interface PrivacyConsentCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  style?: React.CSSProperties;
}

const PrivacyConsentCheckbox = ({
  checked,
  onCheckedChange,
  style,
}: PrivacyConsentCheckboxProps) => {
  const privacyPdfPath = "/iceholidays-assets/privacy.pdf";
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageWidth, setPageWidth] = useState(900);

  useEffect(() => {
    const updatePageWidth = () => {
      const width = Math.min(900, Math.max(window.innerWidth - 48, 280));
      setPageWidth(width);
    };

    updatePageWidth();
    window.addEventListener("resize", updatePageWidth);

    return () => {
      window.removeEventListener("resize", updatePageWidth);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages: loadedPages }: { numPages: number }) => {
    setNumPages(loadedPages);
  };

  return (
    <ConsentCheckboxField
      name="privacy_agreed"
      checked={checked}
      onCheckedChange={onCheckedChange}
      linkLabel="Privacy Statement"
      requiredMessage="Please agree to the Privacy Statement to proceed to payment."
      modalTitle="Privacy Statement"
      modalContent={
        <div>
          <Document
            file={privacyPdfPath}
            onLoadSuccess={onDocumentLoadSuccess}
            error="There is no privacy statement available."
            loading="Loading privacy statement..."
          >
            {Array.from(new Array(numPages || 0), (_, index) => (
              <Page key={`privacy_page_${index + 1}`} pageNumber={index + 1} width={pageWidth} />
            ))}
          </Document>
          <a href={privacyPdfPath} target="_blank" rel="noreferrer">Open Privacy Statement PDF in new tab</a>
        </div>
      }
      style={style}
    />
  );
};

export default PrivacyConsentCheckbox;
